import classNames from 'classnames';
import { Col } from 'antd';
import React from 'react';
import { SonarRecordContainer, SonarRecordNameSection, SonarRecordRow, SonarRecordSecondaryInfo } from '.';
export const SonarRecordData = ({ className, isActive, name, onClick, secondaryInfo, sonarObjectType }) => {
    const classes = classNames('sonar-record-data', className);
    return (React.createElement(SonarRecordContainer, { className: classes, onClick: onClick },
        React.createElement(SonarRecordRow, null,
            React.createElement(Col, { flex: 'none' },
                React.createElement(SonarRecordNameSection, { isActive: isActive, name: name })),
            React.createElement(SonarRecordSecondaryInfo, { info: secondaryInfo, sonarObjectType: sonarObjectType }))));
};
